import { HttpClient } from "./HttpClient"

export class BaseService {
	baseUrl = "/"
	
	constructor(baseUrl = "") {
		this.baseUrl += baseUrl
		this.client = new HttpClient()
	}
}
